export default function getPrice({ priceId, agreementId, customPrice }) {
	if (priceId === "custom" || agreementId === "custom") {
		return { ...customPrice, name: "Custom" };
	}

	return priceId;
}
